import React from 'react';
import { Form } from "react-bootstrap";
import classNames from 'classnames';

const RadioButtonGroup = ({
  value,
  error,
  touched,
  id,
  label,
  className,
  ...props
}) => {
  const classes = classNames(
    "input-field",
    {
      "is-success": value || (!error && touched), // handle prefilled or user-filled
      "is-error": !!error && touched
    },
    className
  );

  return (
    <Form.Group className={classes}>
      <fieldset>
        {label && <Form.Label className="control-label">{label} {props.required && <span className="text-danger">*</span>}</Form.Label>}
        <div>
        {props.children}
        </div>
        {touched && error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
      </fieldset>
    </Form.Group>
  );
};

export default RadioButtonGroup;